import Vue from 'vue'
import WarehouseTransformer
from '../../../transformers/catalog/warehouse/warehouse'

/**
 * @author jorge nuñez lópez <>
 *
 * Get available stock for warehouse
 * @return {object}
 */

function urlParamsTransformer(options) {
  return {
    page: options.page,
    size: options.pageSize,
    camp: options.campId,
    ascending_order: options.asc ? true : undefined,
    text: options.text
  }
}

export default (warehouseId, fetchOptions) => {
  const params = fetchOptions ? urlParamsTransformer(fetchOptions) : null

  return Vue.$http.get(`purchase/warehouse/${warehouseId}/stock/`, { params })
    .then(response => {
      const { results, ...paginationInfo} = response.data
      const stock = WarehouseTransformer.fetchStock(results)
      return { stock, paginationInfo }
    })
    .catch((error) => {
      const response = error.response

      if (response && response.status !== 404) {
        throw error
      }
    })
}


// WEBPACK FOOTER //
// ./src/services/purchase/warehouse/fetchStock.js